import AssetService from "@/services/AssetService";
import InspectionAreaService from "@/services/InspectionAreaService";
import DashboardDataService from "@/services/DashboardDataService";

const ServiceFactory = {
    getService(type){
        const serviceMap = {
            AssetService: AssetService,
            InspectionAreaService: InspectionAreaService,
            DashboardDataService: DashboardDataService
        };

        return serviceMap[type] || null;
    },
};

export default ServiceFactory;